import React, { Component, Fragment, Suspense } from "react";
import DataGrid, {
  Column,
  ColumnChooser,
  ColumnFixing,
  Export,
  Grouping,
  GroupPanel,
  HeaderFilter,
  Pager,
  Paging,
  SearchPanel,
  SortByGroupSummaryInfo,
} from "devextreme-react/data-grid";
import DateBox from "devextreme-react/date-box";
import {
  getRequestParams,
  formatDate,
  getBaseApiUrl,
} from "../../helpers/globalfunctions.js";
import moment, { max } from "moment";
import { ToastContainer, toast } from "react-toastify";
import { DairyTripStatus } from "../../helpers/fixcodes";
import { VehicleReplayComponent } from "../replay/VehicleReplayComponent";
import { LoadPanel } from "devextreme-react/load-panel";
import secureLocalStorage from "react-secure-storage";
import { SelectBox } from "devextreme-react";
import Swal from "sweetalert2";
import { Modal } from "reactstrap";

const customStyles = {
  content: {
    width: "80%",
  },
};
const position = { of: "#historydiv" };
export class TripCreateComponent extends Component {
  static displayName = TripCreateComponent.name;

  constructor(props) {
    let currentTime =
      secureLocalStorage.getItem("session_locationTime") === ""
        ? new Date()
        : new Date(secureLocalStorage.getItem("session_locationTime"));
    super(props);
    let fromDatetime = secureLocalStorage.getItem("session_trip_startDateTime");
    let toDatetime = secureLocalStorage.getItem("session_trip_endDateTime");
    this.state = {
      loadPanelVisible: false,

      filterFromDatetime:
        fromDatetime != null
          ? moment(fromDatetime).format("MM/DD/YYYY") + " 00:00"
          : moment(currentTime).format("MM/DD/YYYY") + " 00:00",
      filterToDatetime:
        toDatetime != null
          ? moment(toDatetime).format("MM/DD/YYYY") + " 23:59"
          : moment(currentTime).format("MM/DD/YYYY") + " 23:59",
      filterVehicleList: [],
      vehicleReplayModalOpen: false,
      dataSource: [],
      tripDetails: {},

      exportFileName: "TripTypeChangeLog",
      vehicleId: 0,

      tripDate: moment(currentTime).format("MM/DD/YYYY"),

      isSubmitted: false,
      loadPanelVisible: false,
      filterFromDatetime:
        fromDatetime != null
          ? moment(fromDatetime).format("MM/DD/YYYY") + " 00:00"
          : moment(currentTime).format("MM/DD/YYYY") + " 00:00",
      filterToDatetime:
        toDatetime != null
          ? moment(toDatetime).format("MM/DD/YYYY") + " 23:59"
          : moment(currentTime).format("MM/DD/YYYY") + " 23:59",
      dairyTripGridDataSource: null,
      filterTripStatusDropdownList: null,
      filterServiceTypeDropdownList: null,
      filterVehicleDropdownList: null,
      filterTripStatusApiDropdownList: [],
      assignPoiModelIsOpen: false,
      dairyModalIsOpen: false,
      tripModalIsOpen: false,
      stoppageModelIsOpen: false,
      clrVehicleModelIsOpen: false,
      vehicleReplayModelOpen: false,
      singelData: null,
      isMappedVehicle: [],
      vehicleList: [],
      dropdownpoi: [],
      dropdownTripHour: [],
      assignPoi: [],
      stoppageReport: [],
      clrVehicleId: 0,
      clrScheduleTime: "",
      clrVehicleNo: "",
      clrTripId: 0,
      vehicleId: 0,
      poiId: 0,
      tripId: 0,
      tripStatus: 0,
      tripType: 0,
      vehicle: 0,
      tripHours: 0,
      driverName: "",
      statusTypeId: 0,
      isChecked: false,
      isAssigned: true,
      startDate: moment(currentTime).format("MM/DD/YYYY") + " 00:00",
      endDate: moment(currentTime).format("MM/DD/YYYY") + " 23:59",
      remarks: "",
      vehicleAssignedTrip: {
        fromDate: "",
        tripStatus: "",
        startPoiName: "",
        vehicleNo: "",
        routeNo: "",
        tripType: "",
      },
      showRunningTrip: true,
      stoppageVehicleNo: "",
      stoppageBaseLocation: "",
      stoppageTranspoter: "",
      showAssign: true,
      errors: {
        vehicle: "",
        poiId: 0,
        tripStatus: "",
        tripType: "",
        vehicle: "",
        driverName: "",
      },
      tripDetails: {},
      exportFileName: "Trip",
      vehicleNo: "",
      modelWidth: "100%",
      modelHeight: "100%",
      replayComponentHeight: window.innerHeight * 0.8 - 100 + "px",
      modelMaxMinEnable: false,
      isViewProductModalOpen: false,
      productGridDatasource: [],
    };
    this.handleSearch = this.handleSearch.bind(this);
  }
  componentDidMount() {
    this.getFilterVehicleDropdownLst();
  }
  closeVehicleReplayModal = (e) => {
    e.preventDefault();

    this.setState({ vehicleReplayModelOpen: false });

    setTimeout(() => {
      this.setState({
        state: null,
        replayModel: {},
      });
    }, 50);
  };

  maxMinModal = (e) => {
    e.preventDefault();
    if (this.state.modelMaxMinEnable === false) {
      this.setState({
        modelWidth: "100%",
        modelHeight: "100%",
        replayComponentHeight: window.innerHeight - 100 + "px",
        modelMaxMinEnable: true,
      });
    } else {
      this.setState({
        modelWidth: "80%",
        modelHeight: "80%",
        replayComponentHeight: window.innerHeight * 0.8 - 100 + "px",
        modelMaxMinEnable: false,
      });
    }
  };
  handleToolbarPreparing = (e) => {
    e.toolbarOptions.items.unshift({
      location: "after",
      widget: "dxButton",
      options: {
        icon: "refresh",
        onClick: this.handleSearch.bind(this),
      },
    });
  };

  handleOnFilteToDateChanged = (date) => {
    this.setState({ filterToDatetime: date.value });
  };

  setToday = (e) => {
    e.preventDefault();
    this.setState({
      filterFromDatetime: moment().startOf("day").toDate(),
      filterToDatetime: moment().endOf("day").toDate(),
    });
  };

  handleVehicleChange = (e) => {
    this.setState({
      vehicleId: e.selectedItem != null ? e.selectedItem.vehicleId : 0,
      filterVehicleList: [e.selectedItem.vehicleId],
    });
  };
  setYesterday = (e) => {
    e.preventDefault();
    this.setState({
      filterFromDatetime: moment().subtract(1, "day").startOf("day").toDate(),
      filterToDatetime: moment().subtract(1, "day").endOf("day").toDate(),
    });
  };

  setLast7days = (e) => {
    e.preventDefault();
    this.setState({
      filterFromDatetime: moment().subtract(6, "day").startOf("day").toDate(),
      filterToDatetime: moment().endOf("day").toDate(),
    });
  };

  getFilterVehicleDropdownLst = async () => {
    try {
      let userId = secureLocalStorage.getItem("session_userId");
      let accountId = secureLocalStorage.getItem("session_accountId");
      let locationId = secureLocalStorage.getItem("session_locationId");
      const requestParams = getRequestParams("GET");
      //const response = await fetch(getBaseApiUrl(process.env.REACT_APP_API_BASE_URL) + 'Vehicles/DropdownList/' + userId + "/" + accountId + "/" + locationId, requestParams);
      const response = await fetch(
        getBaseApiUrl(process.env.REACT_APP_API_BASE_URL) +
          "Vehicles/ReportVehicles/" +
          userId,
        requestParams
      );
      const data = await response.json();
      this.setState({
        filterVehicleDropdownList: data.payload,
      });
    } catch (ex) {
      console.log(
        "Error in " +
          this.displayName +
          ".getFilterVehicleDropdownLst function",
        ex
      );
    }
  };
  handleFromValueChanged = (date) => {
    // this.setState({ fromDatetime: date.value });
    this.setState({ filterFromDatetime: date.value });
  };

  handleCreatTrip = (e) => {
    e.preventDefault();
    if (this.state.dataSource[0].address == "") {
      Swal.fire({
        icon: "warning",
        title: "No Data Found",
        text: "Please search valid data to create trip.",
      });
      return;
    }

    let alertmesage = "Are you sure, you want create trip";
    Swal.fire({
      html: alertmesage,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
      allowOutsideClick: false,
    }).then((result) => {
      if (result.isConfirmed) {
        this.setState({ isCreateTrip: true });
        var request = new Object();
        // request.PoiList = new Object();
        // request.PoiList = [];
        request.AccountId = secureLocalStorage.getItem("session_accountId");
        request.LocationId = secureLocalStorage.getItem("session_locationId");
        request.createdBy = secureLocalStorage.getItem("session_userId");
        request.createdDateTime = formatDate(new Date(), "yyyy-MM-dd HH:mm:ss");
        request.vehicleId = this.state.vehicleId;
        // request.RouteId = this.state.routeId;
        // request.GeofenceId = this.state.baseLocationId;
        // request.RouteName = this.state.routeName;
        request.StartPoiName = this.state.dataSource[0].address;
        request.ServiceTypeId = 6;
        request.ScheduleDatetime = formatDate(
          this.state.dataSource[0].dateTime,
          "yyyy-MM-dd HH:mm:ss"
        );
        request.StartLatitude = this.state.dataSource[0].latitude;
        request.StartLongitude = this.state.dataSource[0].longitude;
        request.StartOdometer = this.state.dataSource[0].odometer;
        request.StartLocation = this.state.dataSource[0].address;
        request.EndLatitude = this.state.dataSource[0].elatitude;
        request.EndLongitude = this.state.dataSource[0].elongitude;
        request.EndDateTime = formatDate(
          this.state.dataSource[0].edateTime,
          "yyyy-MM-dd HH:mm:ss"
        );
        request.EndOdometer = this.state.dataSource[0].eodometer;
        request.EndLocation = this.state.dataSource[0].eaddress;
        request.tripDate = formatDate(this.state.tripDate, "yyyy-MM-dd");
        request.StartSpeed = this.state.dataSource[0].speed;
        request.EndSpeed = this.state.dataSource[0].espeed;

        request.TripStatusId = 904;
        request.TripStatusName = "COMPLETED";
        const requestParams = getRequestParams("POST", request);
        fetch(
          getBaseApiUrl(process.env.REACT_APP_TRIPS_API_BASE_URL) +
            "Dairy/CreateManualTrip",
          requestParams
        )
          .then((response) => {
            if (response.ok) return response.json();
          })
          .then((data) => {
            this.setState({ isCreateTrip: false });
            if (data != null) {
              Swal.fire({
                icon : data.message == "Trip created successful." ?  "success" :  "error",
                title: data.message == "Trip already created." ?  "info" :  data.isSuccess ? "Success" : "Oops...",
                text: data.message ,
              }).then((result) => {
                if (data.isSuccess) {
                  if (result.isConfirmed) {
                    // this.handleResetStateData();
                    // window.location.href = "/dairy/trip";
                  }
                  // this.setState({ isCreateTrip: false })
                }
              });
            }
          });
      }
    });
  };

  handleSearch = async () => {
    this.setState({
      dataSource: [],
    });
    try {
      this.setState({ loadPanelVisible: true });
      this.setState({ isNewTrip: true });
      let startDate = this.state.filterFromDatetime;
      let endDateTime = this.state.filterToDatetime;
      var vehicle = [];
      vehicle.push(this.state.filterVehicleId);
      let request = {};
      request.AccountId = secureLocalStorage.getItem("session_accountId");
      request.LocationId = secureLocalStorage.getItem("session_locationId");
      request.UserId = secureLocalStorage.getItem("session_userId");
      request.IndustryId = secureLocalStorage.getItem("session_industryTypeId");
      request.DateFrom = startDate;
      request.DateTo = endDateTime;
      request.ReportType = 1; // Activity Report
      request.ReportTypeId = [1];
      request.VehicleId = this.state.filterVehicleList || [];

      request.PoiId = [];
      request.GridName = "Activity";
      this.setState({ loadPanelVisible: true });
      const requestParams = getRequestParams("POST", request);
      const response = await fetch(
        getBaseApiUrl(process.env.REACT_APP_REPORT_API_BASE_URL) +
          "Tracking/Activity",
        requestParams
      );
      const data = await response.json();
      console.log("Trip Data", data.payload.dataValues);

      const firstItem = data?.payload?.dataValues?.[0] || {};
      const lastItem =
        data?.payload?.dataValues?.[data.payload.dataValues.length - 1] || {};

      this.setState({
        dataSource: [
          {
            id: 1,
            address: firstItem.address || "",
            odometer: firstItem.odometer || 0,
            latitude: firstItem.latitude || 0,
            longitude: firstItem.longitude || 0,
            dateTime: firstItem.dateTime || "",
            status: firstItem.status || "",
            speed: firstItem.speed || 0,
            locationType: firstItem.locationId || "",
            eaddress: lastItem.address || "",
            eodometer: lastItem.odometer || 0,
            elatitude: lastItem.latitude || 0,
            elongitude: lastItem.longitude || 0,
            edateTime: lastItem.dateTime || "",
            estatus: lastItem.status || "",
            espeed: lastItem.speed || 0,
            vehicleId: firstItem.vehicleId || 0,
            vehicleNo: firstItem.vehicleNo || "",
            totalDistance:
              ((lastItem.odometer || 0) - (firstItem.odometer || 0)).toFixed(
                2
              ) || 0,
          },
        ],
      });

      // this.setState({ dataList  :
      //   [{
      //     id: 1,
      //     address: data.payload.dataValues[0].address,
      //     odometer: data.payload.dataValues[0].odometer,
      //     latitude: data.payload.dataValues[0].latitude,
      //     longitude: data.payload.dataValues[0].longitude,
      //     dateTime: data.payload.dataValues[0].dateTime,
      //     status: data.payload.dataValues[0].status,

      //   }]})

      console.log("Trip Data", firstItem);
      // this.setState({ dataSource: this.state.dataList });

      this.setState({ loadPanelVisible: false });
    } catch (err) {
      console.log(
        "Error in " + this.displayName + ".handleSearch function",
        err
      );
      this.setState({ loadPanelVisible: false });
    }
  };

  openReplay = async (e, data) => {
    console.log("Replay Data", data);
    e.preventDefault();
    this.setState({
      tripDate: moment(data.dateTime).format("YYYYMMDDhhmmss"),
      vehicleNo: data.vehicleNo,
    });

    let replaystate = new Object();
    replaystate.tripId = data.id;
    replaystate.vehicleId = data === null ? 0 : data.vehicleId;
    replaystate.sourceUrl = "";
    replaystate.sourceState = this.state;
    replaystate.vehicleReplayModal = true;
    replaystate.fromDatetime = moment(data.dateTime).toDate();
    replaystate.toDatetime = moment(data.edateTime).toDate();
    let tripDetails = new Object();
    tripDetails.jobNumber = 1;
    tripDetails.vehicleNo = data.vehicleNo;
    tripDetails.startDatetime = data.dateTime;
    tripDetails.startLocation = data.startLocation;
    tripDetails.endDatetime = data.edateTime;
    tripDetails.endLocation = data.endLocation;
    tripDetails.tripStatusName = data.tripStatusName;
    tripDetails.routeName = data.routeName;
    tripDetails.startLocation = data.address;
    tripDetails.endLocation = data.eaddress;
    tripDetails.serviceTypeId = data.serviceTypeId;
    this.setState({
      vehicleReplayModelOpen: true,
      state: replaystate,
      vehicleNo: data.vehicleNo,
      replayComponentHeight: window.innerHeight * 0.8 - 80 + "px",
      tripDetails: tripDetails,
    });
  };

  handleBackToTrip = () => {
    sessionStorage.setItem("session_PageName", "Convert Trip");
    window.gtag("event", "page_view", {
      page_title: sessionStorage.getItem("session_PageName"),
      page_location: window.location.pathname,
    });
    window.location.href = "/dairy/trip";
  };
  handleTripDateValueChanged = (date) => {
    this.setState({ tripDate: date.value });
  };

  render() {
    const renderReplayGridCell = (data) => {
      // if (
      //       data.data.tripStatusId == parseInt(DairyTripStatus.STARTED) ||
      //       data.data.tripStatusId == parseInt(DairyTripStatus.COMPLETED)
      //     ) {
      // return <a href="#" title="Replay" onClick={(e) => { this.replayVehicle(e, data.data) }}><i className="far fa-play-circle"></i></a>
      return (
        <a
          href="#"
          title="Replay"
          onClick={(e) => {
            this.openReplay(e, data.data);
          }}
        >
          <i className="far fa-play-circle"></i>
        </a>
      );
      // }
      // return <i className="far fa-play-circle text-gray"></i>;
    };

    return (
      <Fragment>
        <div className="filter-box">
          <div className="card p-1 m-0">
            <div className="card-body p-2">
              <div>
                <div
                  className="form-group pull-left"
                  style={{ marginRight: "8px", width: "170px" }}
                >
                  <div
                    className="form-group has-feedback"
                    style={{ marginLeft: 10 + "px" }}
                  >
                    <label>From Date</label>
                    <DateBox
                      type="datetime"
                      className="replay-date-time"
                      name="filterFromDatetime"
                      placeholder="dd/MM/yyyy HH:mm"
                      displayFormat="dd/MM/yyyy HH:mm"
                      showAnalogClock={true}
                      useMaskBehavior={true}
                      defaultValue={this.state.filterFromDatetime}
                      value={this.state.filterFromDatetime}
                      onValueChanged={this.handleFromValueChanged}
                      width="100%"
                      disabled={false}
                      acceptCustomValue={false}
                    />
                    <div style={{ width: "180px" }}>
                      <span>
                        <a
                          href="#"
                          onClick={(e) => {
                            this.setToday(e);
                          }}
                        >
                          <b>Today</b>
                        </a>
                      </span>
                      &nbsp;|&nbsp;
                      <span>
                        <a
                          href="#"
                          onClick={(e) => {
                            this.setYesterday(e);
                          }}
                        >
                          <b>Yesterday</b>
                        </a>
                      </span>
                      &nbsp;|&nbsp;
                      <span>
                        <a
                          href="#"
                          onClick={(e) => {
                            this.setLast7days(e);
                          }}
                        >
                          <b>Last 7 Days</b>
                        </a>
                      </span>
                    </div>
                  </div>
                </div>
                <div
                  className="form-group pull-left"
                  style={{ marginRight: "8px", width: "170px" }}
                >
                  <div className="form-group">
                    <label> To </label>
                    <DateBox
                      type="datetime"
                      className="replay-date-time"
                      name="filterToDatetime"
                      placeholder="dd/MM/yyyy HH:mm"
                      displayFormat="dd/MM/yyyy HH:mm"
                      showAnalogClock={true}
                      useMaskBehavior={true}
                      defaultValue={this.state.filterToDatetime}
                      value={this.state.filterToDatetime}
                      onValueChanged={this.handleOnFilteToDateChanged}
                      width="100%"
                      disabled={false}
                      acceptCustomValue={false}
                    />
                  </div>
                </div>
                <div
                  className="form-group pull-left"
                  style={{ marginRight: "8px", width: "170px" }}
                >
                  <div className="form-group">
                    <label> Vehicle </label>
                    <SelectBox
                      dataSource={this.state.filterVehicleDropdownList}
                      className="basic-multi-select"
                      classNamePrefix="select"
                      placeholder="Vehicle"
                      defaultValue={0}
                      value={this.state.filterVehicleId}
                      valueExpr="vehicleId"
                      displayExpr="vehicleNo"
                      onSelectionChanged={this.handleVehicleChange}
                      showClearButton={true}
                      disabled={false}
                      searchEnabled={true}
                      width="100%"
                    />
                  </div>
                </div>
                <div
                  className="form-group pull-left"
                  style={{ marginRight: "8px", width: "170px" }}
                >
                  <label>&nbsp;</label>
                  <br />
                  <button
                    type="submit"
                    className="btn btn-success"
                    onClick={this.handleSearch}
                  >
                    <span title="Search">
                      <i className="fas fa-search"></i> Search
                    </span>
                  </button>{" "}
                  &nbsp;&nbsp;
                  <button
                    type="submit"
                    className="btn btn-success"
                    onClick={this.handleBackToTrip}
                  >
                    <span title="Submit">
                      <i className="fas fa-caret-left"></i> Back{" "}
                    </span>
                  </button>
                </div>
                <div
                  className="form-group pull-left"
                  style={{ marginRight: "8px", width: "170px" }}
                >
                  <label>&nbsp;</label>
                  <br />
                  <button
                    className="btn btn-success"
                    onClick={this.handleCreatTrip}
                  >
                    {" "}
                    Create Trip{" "}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="card">
          <div className="card-body">
            <DataGrid
              dataSource={this.state.dataSource}
              keyExpr="id"
              selection={{ mode: "single" }}
              columnsAutoWidth={false}
              showColumnLines={true}
              showRowLines={true}
              showBorders={true}
              width="100%"
              rowAlternationEnabled={false}
              allowColumnResizing={true}
              columnResizingMode="widget"
              onToolbarPreparing={this.handleToolbarPreparing}
            >
              <Column
                dataField="dateTime"
                width={200}
                allowSearch={true}
                allowFiltering={true}
                allowSorting={true}
                caption="Start Date Time "
              />

              <Column
                dataField="address"
                width={200}
                allowSearch={false}
                allowFiltering={false}
                allowSorting={false}
                caption="Start Location "
              />
              <Column
                dataField="odometer"
                width={200}
                allowSearch={false}
                allowFiltering={false}
                allowSorting={false}
                caption="Start Oddometer"
              />
              <Column
                dataField="latitude"
                width={200}
                visible={false}
                allowSearch={true}
                allowFiltering={true}
                allowSorting={true}
                caption="Latitude"
              />
              <Column
                dataField="longitude"
                width={200}
                visible={false}
                allowSearch={true}
                allowFiltering={true}
                allowSorting={true}
                caption="Longitude"
              />

              <Column
                dataField="status"
                width={200}
                visible={false}
                allowSearch={true}
                allowFiltering={true}
                allowSorting={true}
                caption="Status"
              />
              <Column
                dataField="speed"
                width={200}
                visible={false}
                allowSearch={true}
                allowFiltering={true}
                allowSorting={true}
                caption="Speed"
              />

              <Column
                dataField="edateTime"
                width={200}
                allowSearch={true}
                allowFiltering={true}
                allowSorting={true}
                caption="End Date Time "
              />
              <Column
                dataField="eaddress"
                width={200}
                allowSearch={false}
                allowFiltering={false}
                allowSorting={false}
                caption="End Location "
              />
              <Column
                dataField="eodometer"
                width={200}
                allowSearch={false}
                allowFiltering={false}
                allowSorting={false}
                caption="End Oddometer"
              />
              <Column
                dataField="elatitude"
                width={200}
                visible={false}
                allowSearch={true}
                allowFiltering={true}
                allowSorting={true}
                caption="Latitude"
              />
              <Column
                dataField="elongitude"
                width={200}
                visible={false}
                allowSearch={true}
                allowFiltering={true}
                allowSorting={true}
                caption="Longitude"
              />

              <Column
                dataField="estatus"
                width={200}
                visible={false}
                allowSearch={true}
                allowFiltering={true}
                allowSorting={true}
                caption="Status"
              />
              <Column
                dataField="espeed"
                width={200}
                visible={false}
                allowSearch={true}
                allowFiltering={true}
                allowSorting={true}
                caption="Speed"
              />
              <Column
                dataField="totalDistance"
                width={200}
                visible={true}
                allowSearch={false}
                allowFiltering={false}
                allowSorting={false}
                caption="Total Distance"
              />
              <Column
                dataField=""
                caption="Replay"
                width={60}
                allowSearch={false}
                allowFiltering={false}
                allowSorting={false}
                cellRender={renderReplayGridCell}
              />
              <SortByGroupSummaryInfo summaryItem="count" />
              <GroupPanel visible={false} />
              <HeaderFilter visible={true} />

              <SearchPanel
                visible={true}
                highlightCaseSensitive={true}
                width={240}
                placeholder="Search..."
              />
              <Grouping autoExpandAll={true} />
              <Paging defaultPageSize={10} />
              <Pager
                showPageSizeSelector={true}
                allowedPageSizes={[10, 20, 50]}
                showInfo={true}
                visible={true}
              />
              <Export
                fileName={this.state.exportFileName}
                enabled={true}
                allowExportSelectedData={false}
              />
              <ColumnChooser enabled={false} />
              <ColumnFixing enabled={true} />
            </DataGrid>
          </div>
        </div>

        <LoadPanel
          shadingColor="rgba(0,0,0,0.4)"
          position={position}
          visible={this.state.loadPanelVisible}
          showIndicator={true}
          shading={true}
          showPane={true}
          closeOnOutsideClick={false}
        />
        <Modal
          ariaHideApp={false}
          isOpen={this.state.vehicleReplayModelOpen}
          className="gentripcustwidth"
          fade={false}
          onRequestClose={this.closeVehicleReplayModal}
          shouldCloseOnOverlayClick={false}
          contentLabel="Example Modal"
        >
          <form>
            <div
              className="modal-header d-flex justify-content-between align-items-center replay-title"
              style={{ width: "100%" }}
            >
              <h6 className="modal-title flex-grow-1 ">
                Vehicle replay {this.state.vehicleNo}
              </h6>

              <div className="header-buttons" style={{color:"white"}}>
                <button
                  type="button"
                  className="close"
                  onClick={this.maxMinModal}
                >
                  {this.state.modelMaxMinEnable ? (
                    <i className="fas fa-light fa-square"></i>
                  ) : (
                    <i className="fas fa-regular fa-window-restore"></i>
                  )}
                </button>

                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={this.closeVehicleReplayModal}
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
            </div>

            <div className="modal-body">
              <div
                style={{
                  overflowY: "scroll",
                  height: this.state.replayComponentHeight,
                }}
              >
                <Suspense fallback={<div>Loading...</div>}>
                  {this.state.vehicleReplayModelOpen && (
                    <VehicleReplayComponent
                      ref="vehicleReplayComponent"
                      location={this.state}
                    />
                  )}
                </Suspense>
              </div>
            </div>
          </form>
        </Modal>
      </Fragment>
    );
  }
}
